import JQueryView from '../../../../../common/views/jqueryView';
import $ from 'jquery';

export default class FormView extends JQueryView {
  constructor() {
    super('#form_view');

    // eslint-disable-next-line
    // @ts-ignore
    $('.form_date').datetimepicker({
      locale: 'ja',
      format: 'YYYY/MM/DD',
      sideBySide: true,
    });

    // eslint-disable-next-line
    // @ts-ignore
    $('#company_zip_code').jpostal({
      postcode: ['#company_zip_code'],
      address: {
        '#company_prefecture_id': '%3',
        '#company_city': '%4',
      },
    });
  }
}
